import { navItems } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="font-heading text-xl font-black text-white mb-3 block">
                黑料爆料
              </span>
              <p className="text-foreground-300 text-xs md:text-sm leading-relaxed mb-4">
                全网热门黑料爆料与最新黑料爆料每日大赛排行第一站。吃瓜群众每日必刷，第一时间获取娱乐圈最新爆料。
              </p>
              <div className="flex items-center gap-3">
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-white mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li>
                  <a
                    href="#hero"
                    onClick={(e) => handleNavClick(e, '#hero')}
                    className="text-foreground-300 hover:text-white text-xs md:text-sm transition-colors cursor-pointer"
                  >
                    首页
                  </a>
                </li>
                {navItems.slice(0, 3).map((item) => (
                  <li key={item.id}>
                    <a
                      href={item.href}
                      onClick={(e) => handleNavClick(e, item.href)}
                      className="text-foreground-300 hover:text-white text-xs md:text-sm transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-white mb-4">更多链接</h4>
              <ul className="space-y-2.5">
                {navItems.slice(3).map((item) => (
                  <li key={item.id}>
                    <a
                      href={item.href}
                      onClick={(e) => handleNavClick(e, item.href)}
                      className="text-foreground-300 hover:text-white text-xs md:text-sm transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
                <li>
                  <a
                    href="#ranking"
                    onClick={(e) => handleNavClick(e, '#ranking')}
                    className="text-foreground-300 hover:text-white text-xs md:text-sm transition-colors cursor-pointer"
                  >
                    热度榜单
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-white mb-4">合作伙伴</h4>
              <p className="text-foreground-400 text-xs leading-relaxed">
                更多合作伙伴即将入驻，敬请期待。
              </p>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-foreground-400 text-xs">
              &copy; 2026 黑料爆料. 本站内容仅供信息参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-400">
              <a href="#hero" className="hover:text-white transition-colors cursor-pointer">用户协议</a>
              <a href="#hero" className="hover:text-white transition-colors cursor-pointer">隐私政策</a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="hover:text-white transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}